
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams/create",
      function () {
        return require("private-next-pages/teams/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teams/create"])
      });
    }
  